<template>
  <div>
    <div class="review-input-form" v-if="isEditing">
      <div class="form-group">
        <label class="post-links-form">
          <p>記事ID一覧</p>
          <small>※ 改行区切りで記事IDを記載してください</small>
          <textarea :placeholder="`1\n2\n3`" rows="4" v-model="formText" />
          <ul class="link-preview">
            <li
              v-for="(previewPost, i) in previewPostsInForm"
              :key="i"
              class="link-preview__item"
            >
              <a :href="`/${previewPost.id}`" target="_blank">{{
                previewPost.title
              }}</a>
            </li>
          </ul>
        </label>
        <div class="form-group__footer">
          <a class="btn-green" @click="onEndEdit()">追加</a>
          <a class="btn-green" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="input-preview" v-else>
      <ul class="link-preview">
        <li
          v-for="(previewPost, i) in previewPosts"
          :key="i"
          class="link-preview__item"
        >
          <a :href="`/${previewPost.id}`" target="_blank">{{
            previewPost.title
          }}</a>
        </li>
      </ul>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'debounce';
import FooterMenu from '../input-footer-menu.vue';
import { restClient } from '../../libs/restClient';
import { stringify } from 'querystring';

export default {
  name: 'PostLinksEditor',
  components: {
    FooterMenu,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      formText: this.value.posts.join('\n'),
      postMap: {},
      postLinks: {
        posts: this.value.posts,
      },
    };
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          posts: this.postLinks.posts,
        },
        action: 'post-links',
        id: this.id,
      };
    },
    maybePostIDsInFormText() {
      return this.formText
        .split('\n')
        .map((row) => {
          const rowValue = row.trim();

          if (rowValue === '') {
            return null;
          }

          const numberLikeString = (() => {
            // ただの数字っぽかったら数字に変換する
            if (rowValue.match(/^[0-9]+$/)) {
              return rowValue;
            }

            // 同一ドメインの記事URLっぽかったら記事IDに変換する
            try {
              const url = new URL(rowValue);
              if (url.origin === location.origin) {
                return url.pathname.match(/^\/(\d+)/)[1];
              }
            } catch {}

            return null;
          })();

          const numberLike = Number(numberLikeString);
          if (!isNaN(numberLike)) {
            return numberLike;
          }
          return null;
        })
        .filter(Boolean);
    },
    previewPostsInForm() {
      return this.maybePostIDsInFormText
        .map((id) => {
          return this.postMap[id];
        })
        .filter(Boolean);
    },
    previewPosts() {
      return this.postLinks.posts.map((id) => this.postMap[id]).filter(Boolean);
    },
    debouncedFetchPosts() {
      const dispatcher = (...args) => {
        this.fetchPosts(...args);
      };
      return debounce(dispatcher, 800);
    },
  },
  watch: {
    'postLinks.posts': {
      handler() {
        this.debouncedFetchPosts(this.postLinks.posts);
      },
      immediate: true,
    },
    maybePostIDsInFormText: {
      handler() {
        this.debouncedFetchPosts(this.maybePostIDsInFormText);
      },
      immediate: true,
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.postLinks.posts = this.previewPostsInForm.map((post) => post.id);
      this.formText = this.postLinks.posts.join('\n');
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    async fetchPosts(postIDs) {
      this.postMap = {};

      const qs = new URLSearchParams();
      postIDs.forEach((id) => {
        qs.append('ids[]', id);
      });
      try {
        const { data } = await restClient.get(
          `/admins/api/posts?${qs.toString()}`
        );
        this.postMap = data.posts;
      } catch (error) {
        alert('記事の取得に失敗しました');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  &__footer {
    &:nth-child(n + 2) {
      margin-top: 10px;
    }
  }
}

.post-links-form {
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    font-size: 14px;
  }
}

.link-preview {
  font-size: 12px;

  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
